import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = ({ data }) => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const scrollToSection = (id) => {
        if (isHomePage) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <img src={data.logo.src} alt={data.logo.alt} className="footer-logo" />
                            <h3>{data.name}</h3>
                            <p>{data.tagline}</p>
                        </div>

                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><Link to="/about-us">About Us</Link></li>
                                <li><Link to="/committee">Committee</Link></li>
                                <li><Link to="/membership">Membership</Link></li>
                                <li><Link to="/news">News</Link></li>
                                <li><Link to="/events">Events</Link></li>
                                <li><Link to="/gallery">Gallery</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/feedback">Contact</Link></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Contact</h4>
                            <ul>
                                <li><i className="fas fa-envelope"></i> mncwestv@gmail.com</li>
                                <li><i className="fas fa-map-marker-alt"></i> Western Melbourne, VIC</li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h4>Follow Us</h4>
                            <div className="footer-social">
                                <a href={data.facebookUrl} target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <div className="footer-org-info">
                            <p className="org-name">{data.organizationName}</p>
                            <p className="org-details">ABN: {data.abn} | Registration No: {data.registrationNo}</p>
                        </div>
                        <div className="footer-copyright">
                            <p>&copy; {new Date().getFullYear()} {data.organizationName}. All rights reserved.</p>
                            <p className="developer-credit">
                                {data.developer.text}: <a href={data.developer.url} target="_blank" rel="noopener noreferrer">{data.developer.name}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
